// extracted by mini-css-extract-plugin
module.exports = {"gradientPill":"style-module__gradientPill___3m_hA","small":"style-module__small___3s5O9"};